import { jsxs as $, jsx as d, Fragment as we } from "react/jsx-runtime";
import { c as E, I as ue } from "./Section-DOeCOW54.js";
import ne, { forwardRef as me, useRef as ce, useEffect as de, useState as se, useCallback as Ee } from "react";
import { T as D, I as Ne, B as ke, u as Ce } from "./useMediaQuery-BZAMobKw.js";
import { p as Se } from "./purify.es-DRolOuEE.js";
import { c as Ae } from "./_commonjsHelpers-DaMA6jEr.js";
import { F as Te } from "./Tooltip-DLbZm45k.js";
const J = {
  "radio-button": "elo-radio-button",
  "radio-button__label": "elo-radio-button__label",
  "radio-button__input__icon": "elo-radio-button__input__icon",
  "radio-button__input": "elo-radio-button__input",
  "radio-button__input--checked": "elo-radio-button__input--checked",
  "radio-button__input--disabled": "elo-radio-button__input--disabled",
  "radio-button__input--text-disabled": "elo-radio-button__input--text-disabled"
}, Re = me(
  ({ label: t, checked: n, disabled: s, ..._ }, h) => /* @__PURE__ */ $("div", { className: J["radio-button"], children: [
    /* @__PURE__ */ d("label", { className: J["radio-button__label"], children: /* @__PURE__ */ d(
      "input",
      {
        className: E(
          J["radio-button__input"],
          n && J["radio-button__input--checked"],
          s && J["radio-button__input--disabled"]
        ),
        type: "radio",
        ref: h,
        checked: n,
        "aria-label": `${t} radio-button`,
        disabled: s,
        ..._
      }
    ) }),
    /* @__PURE__ */ d(
      D,
      {
        type: "span",
        size: "medium",
        extraClass: E(
          s && J["radio-button__input--text-disabled"]
        ),
        children: t
      }
    )
  ] })
);
Re.displayName = "RadioButton";
const _e = ({
  wrapperRef: t,
  visible: n,
  setVisible: s
}) => {
  const _ = ce(n);
  de(() => {
    _.current = n;
  }, [n]), de(() => {
    const h = (p) => {
      _.current && t.current && !t.current.contains(p.target) && p.target instanceof HTMLElement && p.target.tagName !== "SELECT" && s(!1);
    }, b = () => {
      _.current && t.current && !t.current.contains(document.activeElement) && s(!1);
    };
    return n && (document.addEventListener("click", h), document.addEventListener("focusin", b)), () => {
      document.removeEventListener("click", h), document.removeEventListener("focusin", b);
    };
  }, [t, s, n]);
}, he = (t, n) => {
  t.key === "Enter" && n((s) => !s), t.key === "Escape" && n(!1);
}, fe = (t, n) => {
  var s, _, h, b, p, x;
  if (t.key === "ArrowDown" || t.key === "ArrowRight") {
    t.preventDefault();
    const u = (s = document.activeElement) == null ? void 0 : s.nextElementSibling;
    u ? u.focus() : (h = (_ = n.current) == null ? void 0 : _.firstElementChild) == null || h.focus();
  } else if (t.key === "ArrowUp" || t.key === "ArrowLeft") {
    t.preventDefault();
    const u = (b = document.activeElement) == null ? void 0 : b.previousElementSibling;
    u ? u.focus() : (x = (p = n.current) == null ? void 0 : p.lastElementChild) == null || x.focus();
  }
}, qe = (t, n, s) => t.url ? /* @__PURE__ */ d(
  Ne,
  {
    href: t.url,
    variant: t.variant,
    className: s,
    target: "_blank",
    children: t.text
  },
  n
) : /* @__PURE__ */ d(
  ke,
  {
    onClick: t.onClick || (() => {
    }),
    variant: t.variant,
    className: s,
    children: t.text
  },
  n
), Pe = (t) => {
  const n = Number(t);
  return isNaN(n) ? t : n.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}, Me = (t) => t >= 0 && t <= 2 ? String.fromCharCode(65 + t) : null, He = (t) => {
  let n = Se.sanitize(t);
  n = n.replace(/,/g, "."), n = n.replace(/[^\d.]/g, "");
  const s = n.indexOf(".");
  return s !== -1 && (n = n.slice(0, s + 1) + n.slice(s + 1).replace(/\./g, "")), n;
}, Ke = (t) => t.replace(/^(\d*\.\d{2}).*/, "$1"), Ve = (t, n, s, _) => {
  const h = t.replace(",", "."), b = parseFloat(h);
  return isNaN(b) || b < n || b > s ? _ : "";
}, Ge = (t) => t.toISOString().split("T")[0], Ue = (t) => {
  const n = t.replace(/\s/g, "");
  return /^\d+(,\d{1,2})?$/.test(n);
}, Ye = (t) => Object.fromEntries(
  Object.entries(t).map(([n, s]) => [
    n,
    Pe(s)
  ])
), X = {
  "calculator-title": "elo-calculator-title",
  "calculator-title--full": "elo-calculator-title--full",
  "calculator-title--half": "elo-calculator-title--half",
  "calculator-title__icon": "elo-calculator-title__icon",
  "calculator-title__title": "elo-calculator-title__title",
  "calculator-title__subtitle": "elo-calculator-title__subtitle"
}, Qe = ne.forwardRef(({ title: t, subtitle: n, icon: s, className: _, rounded: h, ...b }, p) => {
  const x = E(X["calculator-title"], _, {
    [X["calculator-title--full"]]: h === "full",
    [X["calculator-title--half"]]: h === "half"
  });
  return /* @__PURE__ */ $("div", { ref: p, ...b, className: x, children: [
    /* @__PURE__ */ $(
      D,
      {
        type: "label",
        size: "large",
        extraClass: X["calculator-title__title"],
        children: [
          s && /* @__PURE__ */ d(
            ue,
            {
              name: s,
              width: "24px",
              height: "24px",
              className: X["calculator-title__icon"]
            }
          ),
          t
        ]
      }
    ),
    n && /* @__PURE__ */ d(
      D,
      {
        type: "label",
        size: "large",
        extraClass: X["calculator-title__subtitle"],
        children: n
      }
    )
  ] });
});
var ge = { exports: {} };
(function(t, n) {
  (function(s, _) {
    t.exports = _(ne);
  })(typeof self < "u" ? self : Ae, function(s) {
    return function() {
      var _ = { 155: function(e) {
        e.exports = s;
      } }, h = {};
      function b(e) {
        var o = h[e];
        if (o !== void 0) return o.exports;
        var r = h[e] = { exports: {} };
        return _[e](r, r.exports, b), r.exports;
      }
      b.d = function(e, o) {
        for (var r in o) b.o(o, r) && !b.o(e, r) && Object.defineProperty(e, r, { enumerable: !0, get: o[r] });
      }, b.o = function(e, o) {
        return Object.prototype.hasOwnProperty.call(e, o);
      }, b.r = function(e) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
      };
      var p = {};
      b.r(p), b.d(p, { useReactToPrint: function() {
        return Z;
      } });
      var x = b(155);
      function u({ level: e = "error", messages: o, suppressErrors: r = !1 }) {
        r || (e === "error" ? console.error(o) : e === "warning" ? console.warn(o) : console.debug(o));
      }
      function V(e, o) {
        if (o || !e) {
          const r = document.getElementById("printWindow");
          r && document.body.removeChild(r);
        }
      }
      function B(e) {
        return e instanceof Error ? e : new Error("Unknown Error");
      }
      function y(e, o) {
        const { documentTitle: r, onAfterPrint: f, onPrintError: A, preserveAfterPrint: k, print: z, suppressErrors: w } = o;
        setTimeout(() => {
          var C, L;
          if (e.contentWindow) {
            let O = function() {
              f == null || f(), V(k);
            };
            if (e.contentWindow.focus(), z) z(e).then(O).catch((T) => {
              A ? A("print", B(T)) : u({ messages: ["An error was thrown by the specified `print` function"], suppressErrors: w });
            });
            else {
              if (e.contentWindow.print) {
                const T = (L = (C = e.contentDocument) === null || C === void 0 ? void 0 : C.title) !== null && L !== void 0 ? L : "", W = e.ownerDocument.title;
                r && (e.ownerDocument.title = r, e.contentDocument && (e.contentDocument.title = r)), e.contentWindow.print(), r && (e.ownerDocument.title = W, e.contentDocument && (e.contentDocument.title = T));
              } else u({ messages: ["Printing for this browser is not currently possible: the browser does not have a `print` method available for iframes."], suppressErrors: w });
              [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i].some((T) => {
                var W, M;
                return ((M = (W = navigator.userAgent) !== null && W !== void 0 ? W : navigator.vendor) !== null && M !== void 0 ? M : "opera" in window && window.opera).match(T);
              }) ? setTimeout(O, 500) : O();
            }
          } else u({ messages: ["Printing failed because the `contentWindow` of the print iframe did not load. This is possibly an error with `react-to-print`. Please file an issue: https://github.com/MatthewHerbst/react-to-print/issues/"], suppressErrors: w });
        }, 500);
      }
      function G(e) {
        const o = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, null);
        let f = r.nextNode();
        for (; f; ) o.push(f), f = r.nextNode();
        return o;
      }
      function q(e, o, r) {
        const f = G(e), A = G(o);
        if (f.length === A.length) for (let k = 0; k < f.length; k++) {
          const z = f[k], w = A[k], C = z.shadowRoot;
          if (C !== null) {
            const L = w.attachShadow({ mode: C.mode });
            L.innerHTML = C.innerHTML, q(C, L, r);
          }
        }
        else u({ messages: ["When cloning shadow root content, source and target elements have different size. `onBeforePrint` likely resolved too early.", e, o], suppressErrors: r });
      }
      const i = `
    @page {
        /* Remove browser default header (title) and footer (url) */
        margin: 0;
    }
    @media print {
        body {
            /* Tell browsers to print background colors */
            color-adjust: exact; /* Firefox. This is an older version of "print-color-adjust" */
            print-color-adjust: exact; /* Firefox/Safari */
            -webkit-print-color-adjust: exact; /* Chrome/Safari/Edge/Opera */
        }
    }
`;
      function U(e, o, r, f) {
        var A, k, z, w, C;
        const { contentNode: L, clonedContentNode: O, clonedImgNodes: T, clonedVideoNodes: W, numResourcesToLoad: M, originalCanvasNodes: ee } = r, { bodyClass: re, fonts: Y, ignoreGlobalStyles: te, pageStyle: oe, nonce: F, suppressErrors: Q, copyShadowRoots: le } = f;
        e.onload = null;
        const a = (A = e.contentDocument) !== null && A !== void 0 ? A : (k = e.contentWindow) === null || k === void 0 ? void 0 : k.document;
        if (a) {
          const H = a.body.appendChild(O);
          le && q(L, H, !!Q), Y && (!((z = e.contentDocument) === null || z === void 0) && z.fonts && (!((w = e.contentWindow) === null || w === void 0) && w.FontFace) ? Y.forEach((c) => {
            const l = new FontFace(c.family, c.source, { weight: c.weight, style: c.style });
            e.contentDocument.fonts.add(l), l.loaded.then(() => {
              o(l);
            }).catch((S) => {
              o(l, ["Failed loading the font:", l, "Load error:", B(S)]);
            });
          }) : (Y.forEach((c) => {
            o(c);
          }), u({ messages: ['"react-to-print" is not able to load custom fonts because the browser does not support the FontFace API but will continue attempting to print the page'], suppressErrors: Q })));
          const ae = oe ?? i, ie = a.createElement("style");
          F && (ie.setAttribute("nonce", F), a.head.setAttribute("nonce", F)), ie.appendChild(a.createTextNode(ae)), a.head.appendChild(ie), re && a.body.classList.add(...re.split(" "));
          const ve = a.querySelectorAll("canvas");
          for (let c = 0; c < ee.length; ++c) {
            const l = ee[c], S = ve[c];
            if (S === void 0) {
              u({ messages: ["A canvas element could not be copied for printing, has it loaded? `onBeforePrint` likely resolved too early.", l], suppressErrors: Q });
              continue;
            }
            const m = S.getContext("2d");
            m && m.drawImage(l, 0, 0);
          }
          for (let c = 0; c < T.length; c++) {
            const l = T[c], S = l.getAttribute("src");
            if (S) {
              const m = new Image();
              m.onload = () => {
                o(l);
              }, m.onerror = (v, R, K, P, j) => {
                o(l, ["Error loading <img>", l, "Error", j]);
              }, m.src = S;
            } else o(l, ['Found an <img> tag with an empty "src" attribute. This prevents pre-loading it.', l]);
          }
          for (let c = 0; c < W.length; c++) {
            const l = W[c];
            l.preload = "auto";
            const S = l.getAttribute("poster");
            if (S) {
              const m = new Image();
              m.onload = () => {
                o(l);
              }, m.onerror = (v, R, K, P, j) => {
                o(l, ["Error loading video poster", S, "for video", l, "Error:", j]);
              }, m.src = S;
            } else l.readyState >= 2 ? o(l) : l.src ? (l.onloadeddata = () => {
              o(l);
            }, l.onerror = (m, v, R, K, P) => {
              o(l, ["Error loading video", l, "Error", P]);
            }, l.onstalled = () => {
              o(l, ["Loading video stalled, skipping", l]);
            }) : o(l, ["Error loading video, `src` is empty", l]);
          }
          const be = "select", pe = L.querySelectorAll(be), xe = a.querySelectorAll(be);
          for (let c = 0; c < pe.length; c++) xe[c].value = pe[c].value;
          if (!te) {
            const c = document.querySelectorAll("style, link[rel~='stylesheet'], link[as='style']");
            for (let l = 0, S = c.length; l < S; ++l) {
              const m = c[l];
              if (m.tagName.toLowerCase() === "style") {
                const v = a.createElement(m.tagName), R = m.sheet;
                if (R) {
                  let K = "";
                  try {
                    const P = R.cssRules.length;
                    for (let j = 0; j < P; ++j) typeof R.cssRules[j].cssText == "string" && (K += `${R.cssRules[j].cssText}\r
`);
                  } catch (P) {
                    u({ messages: ["A stylesheet could not be accessed. This is likely due to the stylesheet having cross-origin imports, and many browsers block script access to cross-origin stylesheets. See https://github.com/MatthewHerbst/react-to-print/issues/429 for details. You may be able to load the sheet by both marking the stylesheet with the cross `crossorigin` attribute, and setting the `Access-Control-Allow-Origin` header on the server serving the stylesheet. Alternatively, host the stylesheet on your domain to avoid this issue entirely.", m, `Original error: ${B(P).message}`], level: "warning" });
                  }
                  v.setAttribute("id", `react-to-print-${l}`), F && v.setAttribute("nonce", F), v.appendChild(a.createTextNode(K)), a.head.appendChild(v);
                }
              } else if (m.getAttribute("href")) if (m.hasAttribute("disabled")) u({ messages: ["`react-to-print` encountered a <link> tag with a `disabled` attribute and will ignore it. Note that the `disabled` attribute is deprecated, and some browsers ignore it. You should stop using it. https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link#attr-disabled. The <link> is:", m], level: "warning" }), o(m);
              else {
                const v = a.createElement(m.tagName);
                for (let R = 0, K = m.attributes.length; R < K; ++R) {
                  const P = m.attributes[R];
                  P && v.setAttribute(P.nodeName, (C = P.nodeValue) !== null && C !== void 0 ? C : "");
                }
                v.onload = () => {
                  o(v);
                }, v.onerror = (R, K, P, j, ye) => {
                  o(v, ["Failed to load", v, "Error:", ye]);
                }, F && v.setAttribute("nonce", F), a.head.appendChild(v);
              }
              else u({ messages: ["`react-to-print` encountered a <link> tag with an empty `href` attribute. In addition to being invalid HTML, this can cause problems in many browsers, and so the <link> was not loaded. The <link> is:", m], level: "warning" }), o(m);
            }
          }
        }
        M === 0 && y(e, f);
      }
      function N(e, o, r, f) {
        e.onload = () => {
          U(e, o, r, f);
        }, document.body.appendChild(e);
      }
      function Z(e) {
        const { contentRef: o, fonts: r, ignoreGlobalStyles: f, onBeforePrint: A, onPrintError: k, preserveAfterPrint: z, suppressErrors: w } = e;
        return (0, x.useCallback)((L) => {
          V(z, !0);
          const O = function({ contentRef: a, optionalContent: H, suppressErrors: ae }) {
            return H && (a && u({ level: "warning", messages: ['"react-to-print" received a `contentRef` option and a optional-content param passed to its callback. The `contentRef` option will be ignored.'] }), typeof H == "function") ? H() : a ? a.current : void u({ messages: ['"react-to-print" did not receive a `contentRef` option or a optional-content param pass to its callback.'], suppressErrors: ae });
          }({ contentRef: o, optionalContent: L, suppressErrors: w });
          if (!O) return void u({ messages: ["There is nothing to print"], suppressErrors: w });
          const T = O.cloneNode(!0), W = document.querySelectorAll("link[rel~='stylesheet'], link[as='style']"), M = T.querySelectorAll("img"), ee = T.querySelectorAll("video"), re = r ? r.length : 0, Y = (f ? 0 : W.length) + M.length + ee.length + re, te = [], oe = [], F = function() {
            const a = document.createElement("iframe");
            return a.width = `${document.documentElement.clientWidth}px`, a.height = `${document.documentElement.clientHeight}px`, a.style.position = "absolute", a.style.top = `-${document.documentElement.clientHeight + 100}px`, a.style.left = `-${document.documentElement.clientWidth + 100}px`, a.id = "printWindow", a.srcdoc = "<!DOCTYPE html>", a;
          }(), Q = (a, H) => {
            te.includes(a) ? u({ level: "debug", messages: ["Tried to mark a resource that has already been handled", a], suppressErrors: w }) : (H ? (u({ messages: ['"react-to-print" was unable to load a resource but will continue attempting to print the page', ...H], suppressErrors: w }), oe.push(a)) : te.push(a), te.length + oe.length === Y && y(F, e));
          }, le = { contentNode: O, clonedContentNode: T, clonedImgNodes: M, clonedVideoNodes: ee, numResourcesToLoad: Y, originalCanvasNodes: O.querySelectorAll("canvas") };
          A ? A().then(() => {
            N(F, Q, le, e);
          }).catch((a) => {
            k == null || k("onBeforePrint", B(a));
          }) : N(F, Q, le, e);
        }, [e]);
      }
      return p;
    }();
  });
})(ge);
var Je = ge.exports;
const Le = "elo-tabs", Fe = "elo-tabs__button", Ie = "elo-tabs__dropdown", I = {
  tabs: Le,
  tabs__button: Fe,
  "tabs__button--active": "elo-tabs__button--active",
  "tabs__mobile--active": "elo-tabs__mobile--active",
  "tabs__mobile--icon": "elo-tabs__mobile--icon",
  "tabs__mobile--icon--open": "elo-tabs__mobile--icon--open",
  tabs__dropdown: Ie,
  "tabs__dropdown--item": "elo-tabs__dropdown--item",
  "tabs__dropdown--item--active": "elo-tabs__dropdown--item--active",
  "tabs__dropdown--visible": "elo-tabs__dropdown--visible",
  "tabs__dropdown--exit": "elo-tabs__dropdown--exit"
}, Xe = ne.forwardRef(
  ({ tabs: t = [], onChangeFunction: n, ...s }, _) => {
    var G, q;
    const [h, b] = se(((G = t[0]) == null ? void 0 : G.value) || ""), [p, x] = se(!1), u = Ce("(max-width: 767px)"), V = ne.useRef(null), B = ne.useRef(null), y = Ee(
      (i) => {
        b(i), n(i), x(!1);
      },
      [n]
    );
    return _e({ wrapperRef: B, visible: p, setVisible: x }), /* @__PURE__ */ $("div", { ref: _, ...s, className: E(I.tabs, s.className), children: [
      !u && t.map((i, U) => /* @__PURE__ */ d(
        "button",
        {
          onClick: () => y(i.value),
          className: E(I.tabs__button, {
            [I["tabs__button--active"]]: h === i.value
          }),
          children: /* @__PURE__ */ d(D, { type: "label", size: "medium", children: i.name })
        },
        U
      )),
      u && /* @__PURE__ */ d(we, { children: /* @__PURE__ */ $(
        "div",
        {
          ref: B,
          className: I["tabs__mobile--active"],
          onClick: () => x(!p),
          onKeyDown: (i) => he(i, x),
          tabIndex: 0,
          role: "combobox",
          "aria-labelledby": "customSelectLabel",
          "aria-expanded": p,
          children: [
            /* @__PURE__ */ d(D, { type: "label", size: "medium", children: (q = t.find((i) => i.value === h)) == null ? void 0 : q.name }),
            /* @__PURE__ */ d(
              ue,
              {
                name: "ArrowDown",
                height: "24px",
                width: "24px",
                className: E(I["tabs__mobile--icon"], {
                  [I["tabs__mobile--icon--open"]]: p
                })
              }
            ),
            /* @__PURE__ */ d(
              "div",
              {
                ref: V,
                className: E(I.tabs__dropdown, {
                  [I["tabs__dropdown--visible"]]: p,
                  [I["tabs__dropdown--exit"]]: !p
                }),
                "aria-hidden": !p,
                "aria-expanded": p,
                children: t.map((i, U) => /* @__PURE__ */ d(
                  "button",
                  {
                    className: E(I["tabs__dropdown--item"], {
                      [I["tabs__dropdown--item--active"]]: h === i.value
                    }),
                    onClick: () => y(i.value),
                    tabIndex: p ? 0 : -1,
                    onKeyDown: (N) => fe(N, V),
                    children: /* @__PURE__ */ d(D, { type: "paragraph", size: "medium", children: i.name })
                  },
                  U
                ))
              }
            )
          ]
        }
      ) })
    ] });
  }
), g = {
  "select-box": "elo-select-box",
  "select-box__label": "elo-select-box__label",
  "select-box__label--high": "elo-select-box__label--high",
  "select-box__label--low": "elo-select-box__label--low",
  "select-box__label--required": "elo-select-box__label--required",
  "select-box__select": "elo-select-box__select",
  "select-box__select--open": "elo-select-box__select--open",
  "select-box__options": "elo-select-box__options",
  "select-box__options--visible": "elo-select-box__options--visible",
  "select-box__options--exit": "elo-select-box__options--exit",
  "select-box__option": "elo-select-box__option",
  "select-box__option--selected": "elo-select-box__option--selected",
  "select-box__icon": "elo-select-box__icon",
  "select-box__icon--open": "elo-select-box__icon--open",
  "select-box__helper": "elo-select-box__helper",
  "select-box__error": "elo-select-box__error",
  "select-box__wrapper": "elo-select-box__wrapper",
  "select-box__tooltip": "elo-select-box__tooltip"
}, Ze = me(
  ({
    label: t,
    labelProminence: n = "low",
    helperText: s,
    errorText: _,
    options: h,
    startingValue: b,
    getSelectedValue: p,
    formTooltipTitle: x,
    formTooltipContent: u,
    wrapperClass: V,
    position: B,
    ...y
  }, G) => {
    const q = _ && _ !== "", [i, U] = se(b || null), [N, Z] = se(!1), e = ce(null), o = ce(null);
    return _e({ wrapperRef: e, visible: N, setVisible: Z }), de(() => {
      i && p && !y.disabled && p(i.value, B, y.name);
    }, [i]), /* @__PURE__ */ $(
      "label",
      {
        className: E(g["select-box"], V),
        "data-error": q,
        children: [
          t && /* @__PURE__ */ $(
            D,
            {
              type: "paragraph",
              size: n === "high" ? "mediumBold" : "medium",
              extraClass: g["select-box__label"],
              children: [
                /* @__PURE__ */ d(
                  "span",
                  {
                    "data-disabled": y.disabled,
                    className: E(
                      n === "high" ? g["select-box__label--high"] : g["select-box__label--low"]
                    ),
                    children: t
                  }
                ),
                " ",
                y.required ? /* @__PURE__ */ d(
                  "span",
                  {
                    "aria-label": "Required",
                    className: g["select-box__label--required"],
                    children: "*"
                  }
                ) : null
              ]
            }
          ),
          /* @__PURE__ */ d(
            "select",
            {
              ref: G,
              ...y,
              "aria-hidden": "true",
              tabIndex: -1,
              defaultValue: i == null ? void 0 : i.value,
              children: h.map((r) => /* @__PURE__ */ d("option", { value: r.value, children: r.label }, r.value))
            }
          ),
          /* @__PURE__ */ $("div", { className: g["select-box__wrapper"], children: [
            /* @__PURE__ */ $(
              "div",
              {
                ref: e,
                role: "combobox",
                "aria-labelledby": "customSelectLabel",
                "aria-expanded": N,
                className: E(g["select-box__select"], {
                  [g["select-box__select--open"]]: N
                }),
                id: `select-box-${t}`,
                onClick: (r) => {
                  r.stopPropagation(), Z((f) => !f);
                },
                tabIndex: 0,
                "data-disabled": y.disabled,
                "data-error": q,
                onKeyDown: (r) => he(r, Z),
                children: [
                  /* @__PURE__ */ d(D, { type: "paragraph", size: "small", children: i && i.label }),
                  /* @__PURE__ */ d(
                    ue,
                    {
                      name: "ArrowDown",
                      width: "24px",
                      height: "24px",
                      className: E(g["select-box__icon"], {
                        [g["select-box__icon--open"]]: N
                      }),
                      "data-disabled": y.disabled
                    }
                  ),
                  /* @__PURE__ */ d(
                    "div",
                    {
                      ref: o,
                      role: "listbox",
                      "aria-hidden": !N,
                      className: E(g["select-box__options"], {
                        [g["select-box__options--visible"]]: N,
                        [g["select-box__options--exit"]]: !N
                      }),
                      children: h.map((r) => /* @__PURE__ */ d(
                        "button",
                        {
                          role: "option",
                          "aria-selected": i === r,
                          className: E(g["select-box__option"], {
                            [g["select-box__option--selected"]]: (i == null ? void 0 : i.value.toString()) === r.value.toString()
                          }),
                          onClick: () => U({
                            value: r.value.toString(),
                            label: r.label
                          }),
                          onKeyDown: (f) => fe(f, o),
                          tabIndex: N ? 0 : -1,
                          children: /* @__PURE__ */ d(D, { type: "paragraph", size: "small", children: r.label })
                        },
                        r.value
                      ))
                    }
                  )
                ]
              }
            ),
            x && u && /* @__PURE__ */ d(
              Te,
              {
                title: x,
                className: g["select-box__tooltip"],
                children: u
              }
            )
          ] }),
          _ && _.length > 0 ? /* @__PURE__ */ d(
            D,
            {
              size: "small",
              type: "paragraph",
              extraClass: g["select-box__error"],
              children: _
            }
          ) : s ? /* @__PURE__ */ d(
            D,
            {
              size: "small",
              type: "paragraph",
              extraClass: g["select-box__helper"],
              "data-disabled": y.disabled,
              children: s
            }
          ) : null
        ]
      }
    );
  }
);
export {
  Qe as C,
  Re as R,
  Ze as S,
  Xe as T,
  He as a,
  Ge as b,
  fe as c,
  Pe as f,
  he as h,
  Ue as i,
  Je as l,
  Me as n,
  Ye as o,
  qe as r,
  Ke as s,
  _e as u,
  Ve as v
};
